import React from 'react';
import PropTypes from 'prop-types';
import ProjectImages from '../../components/ProjectImages';

const ProjectImagePage = ({ data, history }) => (
  <ProjectImages data={data} history={history} />
);

export default ProjectImagePage;

ProjectImagePage.propTypes = {
  data: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export const query = graphql`
  query ImageDetailQuery($slug: String!) {
    allContentfulProject(sort: { fields: [date] }) {
      edges {
        node {
          date
          images {
            id
          }
          slug
        }
      }
    }
    contentfulProject(slug: { eq: $slug }) {
      slug
      title
      client
      buyLink
      poem {
        __typename
        ... on ContentfulStanza {
          alignment
          text {
            childMarkdownRemark {
              html
              htmlAst
            }
          }
        }
      }
      images {
        __typename
        ... on ContentfulProjectImage {
          title
          fullscreen
          asset {
            file {
              url
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/ProjectImages/index.jsx